import { type AxiosInstance } from "axios";
import type {
  CommercialPictureAnalyzeByDetailIdsRequest,
  CommercialPictureAnalyzeByDetailIdsResponse,
} from "./types";

/**
 * 取得済み商業登記から後追いで解析を実行するAPIを呼び出す。
 * 不動産の POST /all-matters-analyze/picture-request 相当。
 */
export const PostCommercialPictureRequestAnalyzeAPI = async (
  apiClient: AxiosInstance,
  requests: CommercialPictureAnalyzeByDetailIdsRequest
): Promise<CommercialPictureAnalyzeByDetailIdsResponse> => {
  const response =
    await apiClient.post<CommercialPictureAnalyzeByDetailIdsResponse>(
      "/commercial-picture-analyze/commercial-picture-request",
      requests
    );
  return response.data;
};
